export function parsePhoneNumber(phoneNumber) {
	const cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');
	if (cleanedNumber.startsWith('+')) {
		return cleanedNumber;
	} else {
		return cleanedNumber.replace(/\D/g, '');
	}
}

export function checkValidPhoneNumber(value) {
	const regex = /^\+?(?:\d+[\-.() ])*\d+$/g;
	return regex.test(value);
}
